import { atom } from 'recoil';

export const newRegulatoryTrainingMatrixEditionModeAtom = atom<boolean>({
	key: 'newRegulatoryTrainingMatrixEdition',
	default: false,
});
